import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import {Grid, Box, Button, Select, MenuItem} from '@material-ui/core';
import { LoadingButton } from '@mui/lab';
import TextField from '@mui/material/TextField';
import Stack from '@mui/material/Stack';
import Snackbar from '@mui/material/Snackbar';
import Alert from '@mui/material/Alert';
import Dialog from '@material-ui/core/Dialog';
import MuiDialogTitle from '@material-ui/core/DialogTitle';
import MuiDialogContent from '@material-ui/core/DialogContent';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import Typography from '@material-ui/core/Typography';
import axios from 'axios';
import { useSelector } from 'react-redux';
import * as env from '../utils/EnvVars';
import SelectDifficultyInc from '../components/SelectDifficultyInc';

const styles = (theme) => ({
  root: {
    margin: 0,
    padding: theme.spacing(2),
  },
  closeButton: {
    position: 'absolute',
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: theme.palette.grey[500],
  },
});

var vertical='top',horizontal='center';

const DialogTitle = withStyles(styles)((props) => {
  const { children, classes, onClose, ...other } = props;
  return (
    <MuiDialogTitle disableTypography className={classes.root} {...other}>
      <Typography variant="h6">{children}</Typography>
      {onClose ? (
        <IconButton aria-label="close" className={classes.closeButton} onClick={onClose}>
          <CloseIcon />
        </IconButton>
      ) : null}
    </MuiDialogTitle>
  );
});

const DialogContent = withStyles((theme) => ({
  root: {
    padding: theme.spacing(2),
  },
}))(MuiDialogContent);

const CustomizedDialogs = React.forwardRef((props, ref) => {  
  const userObj = useSelector(state => state.userDetails);
  const [open, setOpen] = React.useState(false); 
  const [severityAlert, setSeverityAlert] = React.useState("error");
  const [showAlert, setShowAlert] = React.useState(false);
  const [alertMessage, setAlertMessage] = React.useState("");
  const [saveLoading, setSaveLoading] = React.useState(false); 
  
  const [difficultyList, setDifficultyList] = React.useState([]);
  const [gradeList, setGradeList] = React.useState([]);
  
  const [templateTitle, setTemplateTitle] = React.useState("");
  const [totalNoOfQues, setTotalNoOfQues] = React.useState(0);
  const [totalQuesKwd, setTotalQuesKwd] = React.useState(0);
  const [totalTime, setTotalTime] = React.useState(0);
  const [diffIds, setDiffIds] = React.useState("0");
  const [diffNames, setDiffNames] = React.useState("Any");
  const [gradeId, setGradeId] = React.useState(0);
  const [gradeName, setGradeName] = React.useState("Any");
  const [marksCorrectAns, setMarksCorrectAns] = React.useState(0);
  const [marksIncorrectAns, setMarksIncorrectAns] = React.useState(0);
  const [marksNotAns, setMarksNotAns] = React.useState(0);


  React.useImperativeHandle(ref, () => ({
    handleClickOpen(){
      setOpen(true);
    }
  }));
  
  const handleClose = () => {
    setOpen(false);
  };

  function hideAlert(){
		setShowAlert(false);
	}


  React.useEffect(() => {
    if(open){
      getApiData();
    }	
    if(open && props.dataObj && props.dataObj.autoId){
      setTemplateTitle(props.dataObj.templateTitle);	
      setTotalNoOfQues(props.dataObj.totalNoOfQues);
      setTotalQuesKwd(props.dataObj.totalQuesKwd);
      setTotalTime(props.dataObj.totalTime);
      setDiffIds(props.dataObj.difficultyIds);
      setDiffNames(props.dataObj.difficultyNames);
      setGradeId(props.dataObj.gradeId);
      setGradeName(props.dataObj.gradeName);
      setMarksCorrectAns(props.dataObj.marksCorrectAns);
      setMarksIncorrectAns(props.dataObj.marksIncorrectAns);
      setMarksNotAns(props.dataObj.marksNotAns);

    }else{
      setTemplateTitle("");
      setTotalNoOfQues(0);
      setTotalQuesKwd(0);
      setTotalTime(0);
      setDiffIds("0");
      setDiffNames("Any");
      setGradeId(0);
      setGradeName("Any");
      setMarksCorrectAns(0);
      setMarksIncorrectAns(0);
      setMarksNotAns(0);
    
    }
	}, [props.dataObj,open]);

  async function getApiData(){
    let axiosHeader = {
      headers: {
        'Content-Type': 'multipart/mixed',
        'loginId': userObj.loginId,
        'token': userObj.token,
        'device': 'web'					
      }
    };
    let endpoints1 = env.API_URL+"/exams/read/difficulty";
    let endpoints2 = env.API_URL+"/exams/read/grades";

    const axiosrequest1 = axios.get(endpoints1,axiosHeader);
    const axiosrequest2 = axios.get(endpoints2,axiosHeader);

    await axios.all([axiosrequest1, axiosrequest2]).then(axios.spread(function(res1, res2) {
      setDifficultyList(res1.data.obj.list);
      setGradeList(res2.data.obj.list);
    
    }));
  }

	function saveData(){    
    
    if(!templateTitle){
      setSeverityAlert("error");
      setShowAlert(true);
      setAlertMessage("Enter template title");			
      return false;
    } 

    if(!totalNoOfQues){
      setSeverityAlert("error");
      setShowAlert(true);
      setAlertMessage("Enter total no of ques");			
      return false;
    }  
    
		if(templateTitle && totalNoOfQues && totalNoOfQues>1){ 
      setSaveLoading(true);

			let axiosHeader = {
				headers: {
					'Content-Type': 'multipart/mixed',
					'loginId': userObj.loginId,
					'token': userObj.token,
					'device': 'web'	
				}
			}; 
			const data = new FormData();
      if(props.dataObj && props.dataObj.autoId){
        data.append('id', props.dataObj.autoId);
      }
      data.append('templateTitle', templateTitle);
      data.append('totalNoOfQues', totalNoOfQues);
      data.append('totalQuesKwd', totalQuesKwd);
      data.append('totalTime', totalTime);
      data.append('difficultyIds', diffIds);
      data.append('difficultyNames', diffNames);
      data.append('gradeId', gradeId);
      data.append('gradeName', gradeName);
      data.append('marksCorrectAns', marksCorrectAns);
      data.append('marksIncorrectAns', marksIncorrectAns);
      data.append('marksNotAns', marksNotAns);
    
      let apiURL='/exams/create/selftest-options-objective';
      let myMessage="Selftest options template has been created.";
      if(!props.clone && props.dataObj && props.dataObj.autoId){
          apiURL='/exams/update/selftest-options-objective';
          myMessage="Selftest options template has been updated.";
      }
             
			axios.post(env.API_URL+apiURL, data, axiosHeader)
			.then((response) => {
        setSaveLoading(false);
				//console.log("RESPONSE RECEIVED: ", response.data.responseTxt);
				if(response.data.responseTxt==="success"){
          setSeverityAlert("success");
          setOpen(false);
					setShowAlert(true);
					setAlertMessage(myMessage);
          props.updatedList(response.data.obj.list);	
					return false;
        }else if(response.data.responseTxt==="alreadyexistserror"){
            setSeverityAlert("error");
            setOpen(true);
            setShowAlert(true);
            setAlertMessage("This selftest options template was created earlier. Enter another exam limit");
            return false;  					
				}else{
          setSeverityAlert("error");
					setShowAlert(true);
					setAlertMessage("It could not be saved.");			
					return false;
				}
			})
			.catch((error) => {
				console.log("ERROR: ", error);
			})	
		}		
	}
  
  function handleGrade(val){
    let valArr = val.split('#');
    setGradeId(valArr[0]);
    setGradeName(valArr[1]);
  }

  function updateDifficultyNames(diffIdz,diffNamez){
    setDiffIds(diffIdz);
    setDiffNames(diffNamez);
  }

  return (
    <>
      <Dialog fullWidth maxWidth="md" onClose={handleClose} aria-labelledby="customized-dialog-title" open={open}>
        <DialogTitle style={{marginBottom:'-30px'}} onClose={handleClose}></DialogTitle>
          <DialogContent >
            <Grid item   md={12} xs={12} className="test-instructions" >
                  <div className="btmbdrgry"><h3>{props.clone?<>Clone</>:(props.dataObj && props.dataObj.autoId>0)?<>Edit</>:<>New</>} Selftest Options Objective</h3></div>
                  <p>
                      <table style={{backgroundColor:'#000000',width:'100%' }} cellSpacing="1" cellPadding="3" >
                        <tr style={{backgroundColor:'#FFFFFF'}} >
                            <td>Template Title</td>
                            <td style={{textAlign:'center'}} >
                            <TextField onChange={event => setTemplateTitle(event.target.value)} value={templateTitle} placeholder={'Template Title'} sx={{width:'99%',fontSize: 10}} variant="standard" />
                            </td>                            
                        </tr>
                        <tr style={{backgroundColor:'#FFFFFF'}} >
                            <td>Total No Of Ques (For Topic)</td>
                            <td style={{textAlign:'center'}} >
                            <TextField onChange={event => setTotalNoOfQues(event.target.value)} value={totalNoOfQues} placeholder={'Total No Of Ques for topic'} sx={{width:'99%',fontSize: 10}} variant="standard" />
                            </td>                            
                        </tr>
                        <tr style={{backgroundColor:'#FFFFFF'}} >
                            <td>Total No Of Ques (For Keyword)</td>
                            <td style={{textAlign:'center'}} >
                            <TextField onChange={event => setTotalQuesKwd(event.target.value)} value={totalQuesKwd} placeholder={'Total No Of Ques for keyword'} sx={{width:'99%',fontSize: 10}} variant="standard" />
                            </td>                            
                        </tr>
                        <tr style={{backgroundColor:'#FFFFFF'}} >
                            <td>Total Time (Minutes)</td>
                            <td style={{textAlign:'center'}} >
                            <TextField onChange={event => setTotalTime(event.target.value)} value={totalTime} placeholder={'Total Time'} sx={{width:'99%',fontSize: 10}} variant="standard" />
                            </td>                            
                        </tr>
                        <tr style={{backgroundColor:'#FFFFFF'}} >
                            <td>Degree Of Difficulty</td>
                            <td>
                              <SelectDifficultyInc 
                                open={open}
                                difficultyIds={diffIds} 
                                difficultyNames={diffNames} 
                                difficultyList={difficultyList} 
                                updateDifficultyNames={updateDifficultyNames} 
                                
                              />
                            </td>                            
                        </tr>
                        <tr style={{backgroundColor:'#FFFFFF'}} >
                            <td>Grade</td>
                            <td>
                              <Select 
                                  style={{width:'100%'}}
                                  // classes={{ paper: classes.paper }}
                                  labelId="select-class-label"
                                  id="select-class"
                                  value={gradeId+'#'+gradeName}									
                                  onChange={event => handleGrade(event.target.value)}
                                  variant="standard"
                                >
                                    <MenuItem value={0+'#'+'Any'} >Any</MenuItem>
                                    {(gradeList && gradeList.length>0)?gradeList.map((row,i)=>(
                                          <MenuItem key={'tchr'+i} value={row.autoId+'#'+row.gradeName}>{row.gradeName}</MenuItem>
                                    )):null}                
                                </Select>
                            </td>                            
                        </tr>
                        <tr style={{backgroundColor:'#FFFFFF'}} >
                            <td>Marks Correct Ans</td>
                            <td style={{textAlign:'center'}} >
                            <TextField onChange={event => setMarksCorrectAns(event.target.value)} value={marksCorrectAns} placeholder={'Marks Correct Ans'} sx={{width:'99%',fontSize: 10}} variant="standard" />
                            </td>                            
                        </tr>
                        <tr style={{backgroundColor:'#FFFFFF'}} >
                            <td>Marks Incorrect Ans</td>
                            <td style={{textAlign:'center'}} >
                            <TextField onChange={event => setMarksIncorrectAns(event.target.value)} value={marksIncorrectAns} placeholder={'Marks Incorrect Ans'} sx={{width:'99%',fontSize: 10}} variant="standard" />
                            </td>                            
                        </tr>
                        <tr style={{backgroundColor:'#FFFFFF'}} >
                            <td>Marks Not Ans</td>
                            <td style={{textAlign:'center'}} >
                            <TextField onChange={event => setMarksNotAns(event.target.value)} value={marksNotAns} placeholder={'Marks Not Ans'} sx={{width:'99%',fontSize: 10}} variant="standard" />
                            </td>                            
                        </tr>
                      </table>

                      <Box mt={2}>
                          <Button onClick={() => {handleClose()}} style={{marginRight:12}} size="small" variant="outlined" >Cancel</Button>
					    	          {saveLoading?
                          <LoadingButton loading={saveLoading} loadingPosition='start' startIcon={<div style={{marginRight:15}}></div>} style={{backgroundColor:'#008000',color:'#FFF',marginRight:10}} size="small" variant="contained"  >Saving...</LoadingButton>
					    	          :
                          <Button onClick={() => {saveData()}} style={{backgroundColor:'#008000',color:'#FFF',marginRight:10}} size="small" variant="contained"  >Save</Button>
                          }
                      </Box>

                  </p>
            </Grid>
          </DialogContent>
      </Dialog>
      
        <Stack spacing={2} sx={{ width: '100%' }}>
					<Snackbar open={showAlert} autoHideDuration={6000} onClose={hideAlert} anchorOrigin={{vertical,horizontal}}  >
						<Alert onClose={hideAlert} variant="filled" severity={severityAlert} sx={{ width: '100%' }}>
							{alertMessage}
						</Alert>
					</Snackbar>
				</Stack>

    </>
  );

});

export default CustomizedDialogs;